import { type KeyConcept } from '@editor2/types/pageElements';
import { normalizeConcept } from '@editor2/containers/PageElementsPage/components/EocCheckinChatbot/helpers';

/**
 * Renders a key_concepts array as a human-readable, line-oriented string so the
 * shared word-diff viewer can show added/removed/edited concepts clearly
 * (mirrors GeoMapDataDiff's approach for the `data` attribute).
 */
export const conceptsToString = (
	concepts: Array<KeyConcept | string> | undefined
): string => {
	if (!concepts || concepts.length === 0) return '(no key concepts)';

	return concepts
		.map((raw, i) => {
			const { concept, description } = normalizeConcept(raw);
			const lines = [`${i + 1}. ${concept || '(empty)'}`];
			if (description) lines.push(`   ↳ ${description}`);
			return lines.join('\n');
		})
		.join('\n');
};
